import type React from 'react';
import MaterialIcon from './MaterialIcon';

type TProps = {
  text?: string;
  onClickAdd?: CallableFunction;
  iconOverride?: string;
  iconClassesOverride?: string[];
};

export const AddButton: React.FC<TProps> = ({
  text,
  onClickAdd,
  iconOverride,
  iconClassesOverride,
}) => {
  return (
    <button
      type='button'
      data-testid='add-button'
      className={`flex items-center border-0 bg-transparent p-0 hover:text-primary-base text-gray-600 ${
        text ? 'mb-6' : ''
      }`}
      onClick={() => onClickAdd?.()}>
      <div className='w-fit h-full rounded-full p-0 bg-neutral-50 transition-all duration-500 shadow-outline-gray hover:shadow-outline-gray-lg'>
        <MaterialIcon
          icon={iconOverride ?? 'add'}
          classes={
            iconClassesOverride ?? [
              'text-6xl',
              'text-gray-500',
              'transition-all',
              'duration-500',
              'flex',
              'items-center',
              'justify-center',
              'hover:text-primary-base',
              'w-[40px]',
              'h-[40px]',
            ]
          }
        />
      </div>
      {text && (
        <p className='ml-4 transition-all duration-500 text-base font-medium text-gray-600-text whitespace-nowrap flex items-center h-full'>
          {text}
        </p>
      )}
    </button>
  );
};

export default AddButton;
